import React from 'react';
import { Link } from 'react-router-dom';
import SharedNavbar from '../components/SharedNavbar';
import './MembershipPage.css';

const MembershipPage = () => {
  return (
    <div className="membership-page">
      <SharedNavbar />

      {/* ===== HERO ===== */}
      <section className="mp-hero">
        <div className="mp-hero-content">
          <h1>Become a Member</h1>
          <p>
            Advance your impact in data — join a community committed to
            raising standards and shaping the future of data management.
          </p>
        </div>
      </section>

      {/* ===== CHOOSE ROUTE ===== */}
      <section className="mp-section">
        <div className="mp-container">
          <div className="mp-route-box">
            <h2>Choose Your Membership Route</h2>
            <p>
              DAMA Tunisia offers membership options for individuals and corporate teams.
              Please select the appropriate route below to view the relevant
              membership information and sign-up options.
            </p>
            <div className="mp-route-btns">
              <button className="mp-route-btn active">Individual Membership</button>
            </div>
          </div>
        </div>
      </section>

      {/* ===== BECOME A MEMBER ===== */}
      <section className="mp-section">
        <div className="mp-container">

          <div className="mp-title-bar">
            <h2>Become a Member</h2>
          </div>
          <div className="mp-intro-text">
            <p>
              Joining <strong>DAMA Tunisia</strong> gives you access to an extensive network
              of data professionals, exclusive resources, and career development opportunities.
              Whether you're looking to enhance your skills, gain mentorship, or connect with
              industry leaders, our membership offers valuable benefits tailored to
              individuals and corporate teams.
            </p>
            <p className="mp-scroll-note">
              <strong>Scroll down to learn more about membership benefits</strong>
            </p>
          </div>

          {/* ===== WHY JOIN ===== */}
          <div className="mp-title-bar">
            <h2>Why Join DAMA Tunisia?</h2>
          </div>
          <div className="mp-why-text">
            <p>
              <strong>DAMA's</strong> primary purpose is to promote the understanding,
              development, and practice of managing data and information as key enterprise
              assets to support the organisation.
            </p>
            <p>
              <strong>DAMA Tunisia</strong> is a local chapter of and affiliated with{' '}
              <strong>DAMA International</strong>. Our aim is to nurture a community of
              data professionals in Tunisia who champion the value of data management.
            </p>
            <p>
              <strong>Please note:</strong> joining <strong>DAMA International</strong> or{' '}
              <strong>DAMA Tunisia</strong> does not allow access to member benefits of
              both organisations.
            </p>
          </div>

          {/* ===== BENEFITS ROW 1 ===== */}
          <div className="mp-benefits-grid">

            {/* Col 1 — Professional Development — teal */}
            <div className="mp-benefit-col">
              <div className="mp-benefit-header mp-header-navy">
                <h3>Professional Development</h3>
              </div>
              <div className="mp-benefit-body mp-body-teal">
                <div className="mp-benefit-item">
                  <h4>CDMP Certification</h4>
                  <p>Advance your career with expert-led training & bootcamps designed to enhance your data management skills.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Discounts on Online Courses</h4>
                  <p>Get exclusive savings on specialised data management courses tailored for data professionals.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Corporate Training Options</h4>
                  <p>Access custom training programmes designed to help organisations develop their data management capabilities.</p>
                </div>
              </div>
            </div>

            {/* Col 2 — Events & Networking — white/blue */}
            <div className="mp-benefit-col">
              <div className="mp-benefit-header mp-header-navy">
                <h3>Events &amp; Networking</h3>
              </div>
              <div className="mp-benefit-body mp-body-blue">
                <div className="mp-benefit-item">
                  <h4>Monthly Members-Only Webinars</h4>
                  <p>Gain insights from industry experts through case studies, panel discussions, and interactive Q&A sessions.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Access to Public Webinars</h4>
                  <p>Explore a wide range of topics on data management, delivered by leading professionals in Tunisia and beyond.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Discounted Event Tickets</h4>
                  <p>Enjoy exclusive savings on industry events and conferences relevant to data management in Tunisia.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Meetups &amp; Networking Events</h4>
                  <p>Connect with data professionals at in-person events across Tunisia. Visit our <Link to="/events" className="mp-inline-link">Events Page</Link> for upcoming meetups.</p>
                </div>
              </div>
            </div>

            {/* Col 3 — Mentorship — lavender */}
            <div className="mp-benefit-col">
              <div className="mp-benefit-header mp-header-navy">
                <h3>Mentorship Program</h3>
              </div>
              <div className="mp-benefit-body mp-body-lavender">
                <div className="mp-benefit-item">
                  <h4>Support for Data Professionals</h4>
                  <p>Receive expert guidance, whether you are new to the field or an experienced professional.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>One-to-One Mentoring</h4>
                  <p>Get personalised support to help you grow your career and develop new skills in data management.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>DAMA Tunisia Mentoring Scheme</h4>
                  <p>Connect with mentors and mentees to share knowledge, insights, and industry expertise across Tunisia.</p>
                </div>
              </div>
            </div>

          </div>

          {/* ===== BENEFITS ROW 2 ===== */}
          <div className="mp-benefits-grid" style={{ marginTop: '2.5rem' }}>

            {/* Col 1 — Resources & Community — teal */}
            <div className="mp-benefit-col">
              <div className="mp-benefit-header mp-header-navy">
                <h3>Resources &amp; Community</h3>
              </div>
              <div className="mp-benefit-body mp-body-teal">
                <div className="mp-benefit-item">
                  <h4>Access to Past Event Recordings</h4>
                  <p>Revisit expert-led webinars and industry discussions through our resource library.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Exclusive Articles</h4>
                  <p>Gain insights from industry leaders, covering the latest trends in data management.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Join Our Community</h4>
                  <p>
                    ◆ <strong>DAMA Tunisia LinkedIn Group</strong> — Join the discussion with data professionals across Tunisia.<br /><br />
                    ◆ <strong>Regional Sub Groups</strong> — Connect with professionals in your region for local insights and networking.
                  </p>
                </div>
              </div>
            </div>

            {/* Col 2 — CDMP Certification — blue */}
            <div className="mp-benefit-col">
              <div className="mp-benefit-header mp-header-navy">
                <h3>CDMP Certification</h3>
              </div>
              <div className="mp-benefit-body mp-body-blue">
                <div className="mp-benefit-item">
                  <h4>Globally Recognised Certification</h4>
                  <p>The CDMP is managed by DAMA International with local support from DAMA Tunisia.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Industry-Endorsed Accreditation</h4>
                  <p>Showcase your expertise with a certification that validates your knowledge, skills, and experience in data management.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Career Advancement</h4>
                  <p>The CDMP qualification helps professionals demonstrate their competence and progress within the industry.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Stay Ahead with Continuous Learning</h4>
                  <p>Keep up to date with best practices and evolving trends in data management.</p>
                </div>
                <div className="mp-benefit-item">
                  <h4>Specialist Knowledge Development</h4>
                  <p>Expand your expertise beyond specific technology products and understand data management as a core business function.</p>
                </div>
              </div>
            </div>

            {/* Col 3 — DMBoK — lavender */}
            <div className="mp-benefit-col">
              <div className="mp-benefit-header mp-header-navy">
                <h3>DMBoK</h3>
              </div>
              <div className="mp-benefit-body mp-body-lavender">
                <div className="mp-benefit-item">
                  <h4>Data Management Body of Knowledge (DMBoK)</h4>
                  <p>Paper copies of the DMBoK can be purchased from DAMA Tunisia at a discount for members.</p>
                  <Link to="/dmbok" className="mp-inline-link" style={{ fontWeight: 700 }}>Order a Copy Online Here</Link>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="mp-cta">
        <div className="mp-container">
          <div className="mp-cta-grid">
            <Link to="/events" className="mp-cta-btn">
              <strong>Events</strong>
              <span>Discover upcoming and past events</span>
            </Link>
            <Link to="/learning" className="mp-cta-btn">
              <strong>Learning</strong>
              <span>Access our training resources</span>
            </Link>
            <Link to="/about" className="mp-cta-btn">
              <strong>Sponsor us</strong>
              <span>Connect with the Tunisian data community</span>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default MembershipPage;